// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qf_a bhs_sn bhs_va","ForumSearch__img":"qf_b","ForumSearch__searchAdsAndShoppingAds":"qf_c","ForumSearch__results--empty":"qf_e"};